<template>
  <div class="contract-change-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('contractChangeDetail.page.title')" :subtitle="$t('contractChangeDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-search" @click="openSelectContractInfoModel">
          {{ $t('contractChangeDetail.selectContract') }}
        </el-button>
        <el-button icon="el-icon-back" @click="goBack">{{ $t('common.back') }}</el-button>
      </template>
    </ds-page-header>

    <!-- (2) 合同信息面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('contractChangeDetail.contractInfo') }}</span>
      </div>
      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.contractName') }}</span>
          <span class="ds-info-grid__value">{{ contractChangeDetailInfo.contractName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.contractCode') }}</span>
          <span class="ds-info-grid__value ds-num">{{ contractChangeDetailInfo.contractCode || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.contractType') }}</span>
          <span class="ds-info-grid__value">{{ contractChangeDetailInfo.contractTypeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.partyA') }}</span>
          <span class="ds-info-grid__value">{{ contractChangeDetailInfo.partyA || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.aContacts') }}</span>
          <span class="ds-info-grid__value">{{ contractChangeDetailInfo.aContacts || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.aLink') }}</span>
          <span class="ds-info-grid__value ds-num">{{ contractChangeDetailInfo.aLink || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.partyB') }}</span>
          <span class="ds-info-grid__value">{{ contractChangeDetailInfo.partyB || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.bContacts') }}</span>
          <span class="ds-info-grid__value">{{ contractChangeDetailInfo.bContacts || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.bLink') }}</span>
          <span class="ds-info-grid__value ds-num">{{ contractChangeDetailInfo.bLink || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.operator') }}</span>
          <span class="ds-info-grid__value">{{ contractChangeDetailInfo.operator || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.operatorLink') }}</span>
          <span class="ds-info-grid__value ds-num">{{ contractChangeDetailInfo.operatorLink || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.amount') }}</span>
          <span class="ds-info-grid__value ds-num">{{ formatMoney(contractChangeDetailInfo.amount) }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.startTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ contractChangeDetailInfo.startTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.endTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ contractChangeDetailInfo.endTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('contractChangeDetail.signingTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ contractChangeDetailInfo.signingTime || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- (3) 变更主体组件（主体/租期/资产） -->
    <contract-change-main-body v-if="contractChangeDetailInfo.param === 'contractChangeMainBody'"
      ref="contractChangeMainBody" @changeMainBody="handlerMainBody" />
    <contract-change-lease v-show="contractChangeDetailInfo.param === 'contractChangeLease'" ref="contractChangeLease"
      @changeNotify="handlerMainBody" />
    <contract-change-assets v-show="contractChangeDetailInfo.param === 'contractChangeAssets'"
      ref="contractChangeAssets" @changeNotify="handlerMainBody" />

    <!-- (4) 变更说明面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('contractChangeDetail.changeRemark') }}</span>
      </div>
      <el-form class="ds-form">
        <el-form-item :label="$t('contractChangeDetail.changeRemark')">
          <el-input v-model="newContract.changeRemark" type="textarea" :rows="5"
            :placeholder="$t('contractChangeDetail.changeRemarkPlaceholder')" />
        </el-form-item>
      </el-form>
    </div>

    <purchase-approvers v-if="contractChangeDetailInfo.audit === '1001'" ref="purchaseApprovers"
      :call-back-listener="contractChangeDetail" :call-back-function="notify3" flow-type="60006" />

    <div class="ds-submit-bar">
      <el-button type="primary" @click="submitChangeContract">{{ $t('common.submit') }}</el-button>
    </div>

    <choose-contract ref="chooseContract" :emitChooseContract="contractChangeDetailInfo"
      @chooseContract="chooseContract" />
  </div>
</template>

<script>
import { saveContractChangePlan } from '@/api/contract/contractChangeDetailApi'
import ContractChangeMainBody from '@/components/contract/ContractChangeMainBody'
import ContractChangeLease from '@/components/contract/ContractChangeLease'
import ContractChangeAssets from '@/components/contract/ContractChangeAssets'
import PurchaseApprovers from '@/components/contract/purchaseApprovers'
import ChooseContract from '@/components/contract/ChooseContract'
import { getCommunityId } from '@/api/community/communityApi'
import { queryContractRoom } from '@/api/contract/addContractApi'
import { formatMoney } from '@/utils/format'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'ContractChangeDetailList',
  components: {
    ContractChangeMainBody,
    ContractChangeLease,
    ContractChangeAssets,
    PurchaseApprovers,
    ChooseContract,
    DsPageHeader
  },
  data() {
    return {
      contractChangeDetailInfo: {
        contractId: '', contractName: '', contractCode: '', contractType: '', contractTypeName: '',
        partyA: '', partyB: '', aContacts: '', bContacts: '', aLink: '', bLink: '',
        operator: '', operatorLink: '', amount: '', startTime: '', endTime: '', signingTime: '',
        param: '', planType: '', rooms: [], audit: '', staffName: '', nextUserId: ''
      },
      newContract: { changeRemark: '' },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    const param = this.$route.query.param
    this.contractChangeDetailInfo.param = param
  },
  methods: {
    formatMoney(v) { return formatMoney(v) },
    openSelectContractInfoModel() { this.$refs.chooseContract.open() },
    submitChangeContract() {
      if (!this.validateForm()) return
      this.newContract.nextUserId = this.contractChangeDetailInfo.nextUserId
      this.newContract.staffName = this.contractChangeDetailInfo.staffName
      saveContractChangePlan(this.newContract)
        .then(response => {
          if (response.code === 0) {
            this.$message.success(this.$t('common.operationSuccess'))
            this.goBack()
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(error => {
          console.error('Error submitting contract change:', error)
          this.$message.error(this.$t('common.submitFailed'))
        })
    },
    validateForm() {
      if (!this.newContract.changeRemark) {
        this.$message.error(this.$t('contractChangeDetail.changeRemarkRequired'))
        return false
      }
      return true
    },
    goBack() { this.$router.go(-1) },
    handlerMainBody(item) {
      this.newContract = JSON.parse(JSON.stringify(this.contractChangeDetailInfo))
      if (item['rooms']) this.newContract.rooms = item.rooms
      Object.assign(this.newContract, item)
    },
    notify3(info) {
      this.contractChangeDetailInfo.nextUserId = info.staffId
      this.contractChangeDetailInfo.staffName = info.staffName
    },
    chooseContract(contract) {
      this.contractChangeDetailInfo.contractId = contract.contractId
      this.contractChangeDetailInfo.contractName = contract.contractName
      this.contractChangeDetailInfo.contractCode = contract.contractCode
      this.contractChangeDetailInfo.contractType = contract.contractType
      this.contractChangeDetailInfo.contractTypeName = contract.contractTypeName
      this.contractChangeDetailInfo.partyA = contract.partyA
      this.contractChangeDetailInfo.partyB = contract.partyB
      this.contractChangeDetailInfo.aContacts = contract.aContacts
      this.contractChangeDetailInfo.bContacts = contract.bContacts
      this.contractChangeDetailInfo.aLink = contract.aLink
      this.contractChangeDetailInfo.bLink = contract.bLink
      this.contractChangeDetailInfo.operator = contract.operator
      this.contractChangeDetailInfo.operatorLink = contract.operatorLink
      this.contractChangeDetailInfo.amount = contract.amount
      this.contractChangeDetailInfo.startTime = contract.startTime
      this.contractChangeDetailInfo.endTime = contract.endTime
      this.contractChangeDetailInfo.signingTime = contract.signingTime
      if (this.$refs.contractChangeAssets) this.$refs.contractChangeAssets.open(this.contractChangeDetailInfo)
      this.loadContractRooms()
    },
    async loadContractRooms() {
      const res = await queryContractRoom({ contractId: this.contractChangeDetailInfo.contractId, page: 1, row: 500 })
      this.contractChangeDetailInfo.rooms = res.data
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-change-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
}
.ds-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-lg);
  border-bottom: 1px solid var(--ds-gray-200);
}
.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}
.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);
  &__item { display: flex; flex-direction: column; gap: 4px; }
  &__label { font-size: var(--ds-font-size-sm); color: var(--ds-gray-500); }
  &__value { font-size: var(--ds-font-size-md); color: var(--ds-gray-800); word-break: break-all; }
}
.ds-submit-bar {
  text-align: right;
  margin: var(--ds-spacing-lg) 0;
}
</style>
